interface IConfig {
  baseApiUrl: string
}

const config: IConfig = {
  baseApiUrl: process.env.REACT_APP_AUTH_URL || 'https://fastigo.se.haus.se/auth',
}

export default config
